/* eslint-disable */
import React, { Component } from "react";
import {
    Card,
    Row,
    Col,
    Form,
    InputNumber,
    Select,
    Button,
    message,
    Input,
    DatePicker,
    Space,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import axios from "axios";
import { Redirect } from "react-router-dom";

const { Option } = Select;

export default class CreateBooking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            agents: [],
            hotels: [],
            agentOtherOption: false,
            hotelOtherOption: false,
        };
    }

    formRef = React.createRef();

    componentDidMount() {
        this.loadAgents();
        this.loadHotels();
    }

    loadAgents = async () => {
        try {
            const response = await axios.get("https://api.srilankaballooning.com/api/getAgents");
            if (response.data.success) {
                this.setState({ agents: response.data.result });
            } else {
                message.error("Failed to load agents");
            }
        } catch (error) {
            console.error("Error loading agents:", error);
            message.error("Error loading agents");
        }
    };

    loadHotels = async () => {
        try {
            const response = await axios.get("https://api.srilankaballooning.com/api/getHotels");
            if (response.data.success) {
                this.setState({ hotels: response.data.result });
            } else {
                message.error("Failed to load hotels");
            }
        } catch (error) {
            console.error("Error loading hotels:", error);
            message.error("Error loading hotels");
        }
    };

    handleSubmit = async (values) => {
        console.log("Received booking values:", values);
        try {
            // Retrieve USER_ID from rememberedUser cookie
            const rememberedUser = Cookies.get("rememberedUser");
            const USER_ID = rememberedUser ? JSON.parse(rememberedUser).USER_ID : null;

            // If agentOtherOption is true, save the new agent to the database
            if (this.state.agentOtherOption && values.AGENT) {
                const agentResponse = await axios.post("https://api.srilankaballooning.com/api/addAgent", {
                    AGENT_NAME: values.AGENT,
                    IS_ACTIVE: 1,
                });
                if (agentResponse.data.success) {
                    message.success("New agent added successfully");
                    // Reload agents list to include the new one
                    this.loadAgents();
                } else {
                    message.error("Failed to add new agent");
                    return; // stop further processing
                }
            }

            // Similarly, if hotelOtherOption is true, save the new hotel to the database
            if (this.state.hotelOtherOption && values.HOTEL) {
                const hotelResponse = await axios.post("https://api.srilankaballooning.com/api/addHotel", {
                    HOTEL_NAME: values.HOTEL,
                    IS_ACTIVE: 1,
                });
                if (hotelResponse.data.success) {
                    message.success("New hotel added successfully");
                    // Reload hotels list to include the new one
                    this.loadHotels();
                } else {
                    message.error("Failed to add new hotel");
                    return;
                }
            }

            // Prepare values to send to the booking endpoint
            const updatedValues = {
                ...values,
                // Convert the moment object from DatePicker to string format
                DATE: values.DATE ? values.DATE.format("YYYY-MM-DD") : null,
                CREATED_BY: USER_ID,
                EDITED_BY: USER_ID,
                IS_ACTIVE: 1,
            };

            const response = await axios.post(
                "https://api.srilankaballooning.com/api/addBooking",
                updatedValues
            );

            if (response.data.success) {
                message.success("Booking added successfully");
                this.formRef.current.resetFields();
                // Reset "other" options so selectors display normally next time
                this.setState({ agentOtherOption: false, hotelOtherOption: false });
            } else {
                message.error("Failed to add booking");
            }
        } catch (error) {
            console.error("Error adding booking:", error);
            message.error("Failed to add booking");
        }
    };

    render() {
        const inputStyle = { width: "100%" };

        let rememberedUser = Cookies.get("rememberedUser");
        let ROLE = null;
        if (rememberedUser) {
            rememberedUser = JSON.parse(rememberedUser);
            ROLE = rememberedUser.ROLE;
        }
        if (ROLE === "USER_VIEW") {
            return <Redirect to="/bookings" />;
        }

        const { agents, hotels, agentOtherOption, hotelOtherOption } = this.state;

        return (
            <div className="tabled">
                <Row gutter={[16, 16]} justify="left" align="top">
                    <Col xs={24} xl={24}>
                        <Card
                            className="criclebox tablespace mb-24"
                            title="Add Booking Information"
                        >
                            <Form
                                layout="vertical"
                                onFinish={this.handleSubmit}
                                style={{ margin: "20px" }}
                                ref={this.formRef}
                            >
                                <Row gutter={[16, 16]} justify="left" align="top">
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item
                                            label="Booking Date"
                                            name="DATE"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please select the booking date",
                                                },
                                            ]}
                                        >
                                            <DatePicker style={inputStyle} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        {/* Guide Selector */}
                                        <Form.Item label="Guide" name="AGENT">
                                            {agentOtherOption ? (
                                                <Space.Compact style={{ width: "100%" }}>
                                                    <Input placeholder="Enter Guide/Agent Name" allowClear />
                                                    <Button
                                                        type="default"
                                                        icon={<CloseOutlined />}
                                                        onClick={() => {
                                                            this.setState({ agentOtherOption: false });
                                                            this.formRef.current.setFieldsValue({ AGENT: "" });
                                                        }}
                                                    />
                                                </Space.Compact>
                                            ) : (
                                                <Select
                                                    showSearch
                                                    allowClear={true}
                                                    placeholder="Select or add a guide"
                                                    optionFilterProp="children"
                                                    dropdownRender={(menu) => (
                                                        <>
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    cursor: "pointer",
                                                                    borderBottom: "1px solid #f0f0f0",
                                                                }}
                                                                onClick={() => {
                                                                    this.setState({ agentOtherOption: true });
                                                                    this.formRef.current.setFieldsValue({ AGENT: "" });
                                                                }}
                                                            >
                                                                <span style={{ color: "#f5222d", fontWeight: "bold" }}>
                                                                    Other
                                                                </span>
                                                            </div>
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {agents.map((agent) => (
                                                        <Option key={agent.AGENT_ID} value={agent.AGENT_NAME}>
                                                            {agent.AGENT_NAME}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item label="Tour No" name="TOUR_NO">
                                            <Input style={inputStyle} placeholder="Enter tour number" />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={[16, 16]} justify="left" align="top">
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item
                                            label="Passenger Name"
                                            name="PASSENGER_NAME"
                                        >
                                            <Input style={inputStyle} placeholder="Enter passenger name" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item
                                            label="Passenger / Guide Contact"
                                            name="CONTACT"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please enter the contact details",
                                                },
                                            ]}
                                        >
                                            <Input style={inputStyle} placeholder="Enter contact details" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item label="Hotel" name="HOTEL">
                                            {hotelOtherOption ? (
                                                <Space.Compact style={{ width: "100%" }}>
                                                    <Input placeholder="Enter Hotel Name" allowClear />
                                                    <Button
                                                        type="default"
                                                        icon={<CloseOutlined />}
                                                        onClick={() => {
                                                            this.setState({ hotelOtherOption: false });
                                                            this.formRef.current.setFieldsValue({ HOTEL: "" });
                                                        }}
                                                    />
                                                </Space.Compact>
                                            ) : (
                                                <Select
                                                    showSearch
                                                    allowClear={true}
                                                    placeholder="Select or add a hotel"
                                                    optionFilterProp="children"
                                                    dropdownRender={(menu) => (
                                                        <>
                                                            <div
                                                                style={{
                                                                    padding: "8px",
                                                                    cursor: "pointer",
                                                                    borderBottom: "1px solid #f0f0f0",
                                                                }}
                                                                onClick={() => {
                                                                    this.setState({ hotelOtherOption: true });
                                                                    this.formRef.current.setFieldsValue({ HOTEL: "" });
                                                                }}
                                                            >
                                                                <span style={{ color: "#f5222d", fontWeight: "bold" }}>
                                                                    Other
                                                                </span>
                                                            </div>
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {hotels.map((hotel) => (
                                                        <Option key={hotel.HOTEL_ID} value={hotel.HOTEL_NAME}>
                                                            {hotel.HOTEL_NAME}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item label="Pax No" name="PAX_NO">
                                            <InputNumber
                                                style={inputStyle}
                                                placeholder="Enter number of passengers"
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={[16, 16]} justify="left">
                                    <Col xs={24}>
                                        <Form.Item label="Remarks / Other Information" name="REMARKS">
                                            <Input.TextArea
                                                style={inputStyle}
                                                rows={3}
                                                placeholder="Enter remarks or other information"
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={[16, 16]} justify="left">
                                    <Col xs={24}>
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit">
                                                Add Booking
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}
